import './testDetailsViewComponent.scss'
import React from 'react';
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
// import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
// import {AttachFile} from "@mui/icons-material";
// import {CommonService} from "../../../../../shared/services";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import commonService from "../../../../../shared/services/common.service";

interface TestDetailsViewComponentProps {
    testDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const TestDetailsViewComponent = (props: TestDetailsViewComponentProps) => {
        const {
            testDetails,
            onEditModeOpen, canEdit
        } = props;

        // const downloadResultExcel = useCallback((attachment: any, type: string) => {
        //     CommonService.downloadFile(attachment.url, attachment.title || type, 'xlsx')
        // }, []);

        return (
            <div className="panel-details-component details-tab-data-content">
                {testDetails && <>
                    <div className="details-tab-data-header">
                        <div className="view-and-edit-title">Basic Details</div>
                        {canEdit &&
                            <div className="">
                                <ButtonComponent
                                    className={"white-space-nowrap"}
                                    type="button"
                                    color={"primary"}
                                    variant={"outlined"}
                                    startIcon={<EditIcon/>}
                                    fullWidth={true}
                                    handleClick={onEditModeOpen}
                                >
                                    Edit Details
                                </ButtonComponent>
                            </div>
                        }
                    </div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Test Name"}> {testDetails?.name || '-'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Sample Type"}> {testDetails?.sampleType ? commonService.capitalizeFirstLetterOfEachWord(testDetails?.sampleType) : '-'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Sample Quantity"}> {testDetails?.sampleQuantity || '-'} </DetailsDataKeyValueComponent>

                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Test Code"}> {testDetails?.code || '-'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Sample Collection Device Name"}>{testDetails?.sampleCollectionDeviceName ? commonService.capitalizeFirstLetterOfEachWord(testDetails?.sampleCollectionDeviceName) : '-'}</DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Resulting Mode"}> {testDetails?.resultingMode || '-'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                        <DetailsDataKeyValueComponent
                            fullWidth
                            title={"Biomarker(s)"}>
                            {
                                testDetails?.biomarker?.map((item: any) => <ChipComponent label={item.name}/>)
                            }
                        </DetailsDataKeyValueComponent>
                        {/*<DetailsDataKeyValueComponent*/}
                        {/*    title={"Description"}> {testDetails?.description || '-'} </DetailsDataKeyValueComponent>*/}
                    </div>

                    {/*<div className="horizontal-line"/>*/}


                    {/*<>*/}
                    {/*    <Grid container spacing={2}>*/}
                    {/*        <Grid item xs={12} sm={12} md={6} xl={6}>*/}
                    {/*            <div className="view-and-edit-title">Panel Result Template</div>*/}
                    {/*            {*/}
                    {/*                testDetails.panelResultTemplate ?*/}
                    {/*                    <ChipComponent*/}
                    {/*                        className="mrg-top-10"*/}
                    {/*                        label={'Result Template.xls'}*/}
                    {/*                        onClick={() => downloadResultExcel(testDetails.panelResultTemplate, 'Result Template.xls')}*/}
                    {/*                        icon={<AttachFile/>}*/}
                    {/*                    />*/}
                    {/*                    : '-'*/}
                    {/*            }*/}
                    {/*        </Grid>*/}

                    {/*        <Grid item xs={12} sm={12} md={6} xl={6}>*/}
                    {/*            <div className="view-and-edit-title">Bulk Import Template</div>*/}
                    {/*            {*/}
                    {/*                testDetails.bulkImportTemplate ?*/}
                    {/*                    <ChipComponent*/}
                    {/*                        className="mrg-top-10"*/}
                    {/*                        label={'Bulk Import Template.xls'}*/}
                    {/*                        onClick={() => downloadResultExcel(testDetails.bulkImportTemplate, 'Bulk Import Template.xls')}*/}
                    {/*                        icon={<AttachFile/>}*/}
                    {/*                    />*/}
                    {/*                    : '-'*/}
                    {/*            }*/}
                    {/*        </Grid>*/}
                    {/*    </Grid>*/}
                    {/*</>*/}

                </>
                }
            </div>
        )

    }

;

export default TestDetailsViewComponent;
